import DisplayFrameworkInput from './components/DisplayFrameworkInput';
import DisplayFrameworkProvider from './components/DisplayFrameworkProvider';

const DisplayFramework = {
  Input: DisplayFrameworkInput,
  Provider: DisplayFrameworkProvider,
};

const DF = DisplayFramework;

export default DF;
